<template>
    <div class="bax-modal-wrap" v-if="open === true">
        <div class="container">
            <div class="bax-modal-content-wrap bax-bg-foot-link">
                <div class="bax-modal-content bax-modal-icon-content text-center">
                    <slot></slot>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Modal',
    props: {
        open: {
            type: Boolean,
        },
    },
};
</script>
